<template>
  <div id="enlist-wrap">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="enlist-header">
      <button class="enlist-tip1" v-on:click="enlistClick">招募要求</button>
      <button class="enlist-tip2" v-on:click="enlistClick2">招募资格</button>
    </div>
    <div class="enlist-content">
      <!--招募信息-->
      <div class="enlist-user">
        <div class="enlist-box">
          <span>真实姓名</span>
          <input placeholder="(必填项）请输入真实姓名" maxlength="30" v-model="real_name" v-on:focus="focus()"
            v-on:blur="blur()" />
        </div>
        <div class="enlist-box">
          <span>联系方式</span>
          <input placeholder="(必填项）请输入联系人手机号" maxlength="11" v-model="phone" v-on:focus="focus()" v-on:blur="blur()" />
        </div>
        <div class="enlist-box">
          <span>验&nbsp;&nbsp;证&nbsp;&nbsp;码</span>
          <input class="input-code" placeholder="(必填项）请输入验证码" maxlength="6" v-model="code" v-on:focus="focus()"
            v-on:blur="blur()" />
          <div id="codeText" class="button" v-on:click="phoneCodeClick">获取验证码</div>
        </div>
        <div class="enlist-box" v-on:click="selectAddressClick">
          <span>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;区</span>
          <input placeholder="(必填项）未选择" v-model="address" readonly v-on:focus="focus()" v-on:blur="blur()" />
          <div class="next"></div>
        </div>
        <div class="enlist-box">
          <span>身份证号</span>
          <input placeholder="(必填项）请输入身份证号" maxlength="18" v-model="id_card_number" v-on:focus="focus()"
            v-on:blur="blur()" />
        </div>
        <div class="enlist-box" v-on:click="selectGradeClick">
          <span>等级职称</span>
          <input placeholder="(必填项）未选择" v-model="level_title" readonly />
          <div class="next"></div>
        </div>
      </div>
      <!--身份信息-->
      <div class="enlist-info">
        <div class="enlist-title">上传身份证</div>
        <div class="enlist-tip">( 必填项，请保证身份证图片上信息清晰可见)</div>
        <div class="enlist-card">
          <div class="card-box card-left">
            <input type="file" @change="imageClick($event,0)" accept="*.jpg,*.png,*.jpeg" />
            <img class="card-img card-left-img" id="card-left-img" src="../assets/empty.png" />
            <div class="card-tip card-left-tip" id="card-left-tip">上传身份证正面</div>
          </div>
          <div class="card-box card-right">
            <input type="file" @change="imageClick($event,1)" accept="*.jpg,*.png,*.jpeg" />
            <img class="card-img card-right-img" id="card-right-img" src="../assets/empty.png" />
            <div class="card-tip card-right-tip" id="card-right-tip">上传身份证背面</div>
          </div>
        </div>
      </div>
      <div class="enlist-cer">
        <div class="enlist-title">资质上传</div>
        <div class="enlist-tip">( 必填项，最多可上传3张照片)</div>
        <div class="enlist-cer-box">
          <div class="cer-box" v-show='cerImgUrls.length >= 0'>
            <input type="file" @change="imageClick($event,2)" accept="*.jpg,*.png,*.jpeg" />
            <img id="cer-box1" :src="emptyImg" />
            <div class="cer-img-del" v-on:click='delCerImg(0)' v-show='cerImgUrls.length > 0'></div>
          </div>
          <div class="cer-box" v-show='cerImgUrls.length >= 1'>
            <input type="file" @change="imageClick($event,3)" accept="*.jpg,*.png,*.jpeg" />
            <img id="cer-box2" :src="emptyImg" />
            <div class="cer-img-del" v-on:click='delCerImg(1)' v-show='cerImgUrls.length > 1'></div>
          </div>
          <div class="cer-box" v-show='cerImgUrls.length >= 2'>
            <input type="file" @change="imageClick($event,4)" accept="*.jpg,*.png,*.jpeg" />
            <img id="cer-box3" :src="emptyImg" />
            <div class="cer-img-del" v-on:click='delCerImg(2)' v-show='cerImgUrls.length > 2'></div>
          </div>
        </div>
      </div>

      <div class="check-box">
        <img id='msgImg' v-on:click='protocolClick(0)' src="../assets/radio_n.png" />
        <span>我已经阅读并同意<a @click="protocolClick(1)">《中消智库专家协议》</a></span>
      </div>
    </div>
    <bottomButton id="bottomButton" title="提交" :state="1" @click="enlistSubmit"></bottomButton>

    <!--  地址选择  -->
    <AreaView :show="addressVisible" @selectedArea="selectedArea"></AreaView>
    <!-- 弹框提示信息 -->
    <InfoView :show="showInfoView" type="2" @infoViewClick="infoViewClick"></InfoView>
    <InfoView :show="showInfoView2" type="3" @infoViewClick="infoViewClick"></InfoView>
    <!-- 职级选择 -->
    <SPicker :show="showSPicker" type="5" @selectedSPicker="selectedSPicker"></SPicker>
    <!-- 成功弹窗 -->
    <SuccessView :show="showSuccessView" type="1" @successViewClick="successViewClick"></SuccessView>
    <div id="captcha" :class="captchaConfig.config.product === 'bind' ? 'hideHeight' : ''">
      <AliCaptcha :captcha-config="captchaConfig" />
    </div>
  </div>
</template>

<script>
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'
import AreaView from '../components/area-view'
import SPicker from '../components/single-picker'
import InfoView from '../components/info-view'
import SuccessView from '../components/success-view'
import { Toast } from 'mint-ui'
import wxShare from '../wx/weixin.js'
import AliCaptcha from '../components/aliCaptcha.vue'

export default {
  inject: ['reload'], // 界面刷新
  data () {
    const captchaHandler = (captchaObj) => {
      window.captchaObj = captchaObj;
      captchaObj
      .appendTo("#captcha")
      .onReady(function () {
        console.log("ready");
      })
      .onNextReady(function () {
        console.log("nextReady");
      })
      .onBoxShow(function () {
        console.log("boxShow");
      })
      .onError(function (e) {
        console.log(e);
      })
      .onSuccess(() => {
        console.log(window._vueInstance,'window._vueInstance')
        if (window._vueInstance && window._vueInstance.captchaConfig.config.product === "bind") {
          window._vueInstance.validate();
        }
      });
    };
    return {
      addressVisible: false,
      showSPicker: false,
      showInfoView: false,
      showInfoView2: false,
      showSuccessView: false,
      emptyImg: require('../assets/empty.png'),
      isProtocol: 0,
      msgImg_n: require('../assets/radio_n.png'),
      msgImg_s: require('../assets/radio_s.png'),
      province: '',
      city: '',
      area: '',
      address: '',
      real_name: '',
      phone: '',
      code: '',
      id_card_number: '',
      level_title: '',
      card_img_front: '',
      card_img_back: '',
      cerImgs: [],
      cerImgUrls: [],
      captchaConfig: {
        config: {
          captchaId: "347c38155fea93f1450cab541186c39f",
          language: "zho",
          product: "bind",
        },
        handler: captchaHandler,
      },
    }
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({ path: 'home' })
    },
    protocolClick: function (index) {
      if (index === 0) {
        if (this.isProtocol === 0) {
          this.isProtocol = 1
          document.getElementById('msgImg').src = this.msgImg_s
        } else {
          this.isProtocol = 0
          document.getElementById('msgImg').src = this.msgImg_n
        }
      } else {
        window.location.href = 'http://cdn.zxzx119.com/%E4%B8%AD%E6%B6%88%E6%99%BA%E5%BA%93%E4%B8%93%E5%AE%B6%E5%8D%8F%E8%AE%AE.pdf'
      }
    },
    blur: function () {
      if (this.utils.isIphone()) { // iphone 适配键盘 弹出 回弹
        const currentScrollY = window.scrollY
        window.scrollTo(0, currentScrollY)
      } else {
        document.getElementById('bottomButton').style.display = 'block'
      }
    },
    focus: function () {
      if (!this.utils.isIphone()) {
        document.getElementById('bottomButton').style.display = 'none'
      }
    },
    enlistClick: function () { // 招募
      this.showInfoView = true
    },
    enlistClick2: function (e) {
      this.showInfoView2 = true
    },
    infoViewClick: function () {
      this.showInfoView = false
      this.showInfoView2 = false
    },
    selectAddressClick: function () { // 地区选择
      this.addressVisible = true
    },
    selectedArea (province, city, area, code) {
      this.addressVisible = false
      if (province.length <= 0) {
        return
      }
      this.province = province
      this.city = city
      this.area = area
      this.address = province + ' ' + city + ' ' + area
    },
    selectGradeClick: function () {
      this.showSPicker = true
    },
    selectedSPicker: function (value) {
      this.showSPicker = false
      if (value.length <= 0) {
        return
      }
      this.level_title = value
    },
    phoneCodeClick: function () { // 获取验证码
      if(this.utils.loginState()!=1){
        Toast('请先登录')
        return
      }
      if (this.phone.length <= 0) {
        Toast('请输入联系方式')
        return
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入联系方式')
        return
      }
      if (this.captchaConfig.config.product === 'bind') {
        // bind模式：弹出验证框，验证成功后由 onSuccess 回调触发 validate
        window.captchaObj.showCaptcha();
      } else {
        // 非bind模式：直接获取验证结果后发送短信
        this.validate();
      }
    },
    validate () {
      let result = window.captchaObj.getValidate();
      if (!result) {
        alert('请先完成验证！');
        return;
      }
      let params = {
        phone: this.phone,
        captchaOutput: result.captcha_output,
        genTime: result.gen_time,
        lotNumber: result.lot_number,
        passToken: result.pass_token
      }
      var _this = this
      this.utils.POST(this.accountUrl + '/account/riskevalsms', params, function (response) {
        _this.countDown()
      })
    },
    countDown: function () { // 倒计时
      console.log('倒计时==========')
      var maxtime = 60
      let timer = setInterval(function () {
        if (maxtime > 0) {
          --maxtime
          document.getElementById('codeText').innerText = '已发送（' + maxtime + 's）'
        } else {
          clearInterval(timer)
          document.getElementById('codeText').innerText = '获取验证码'
        }
      }, 1000)
    },
    imageClick: function (e, index) { // 资质图片上传
      console.log(e)
      if (this.utils.isImageFile(e) === false) {
        return false
      }
      this.uploadImage(e, index)
    },
    uploadImage: function (file, index) {
      console.log('图片上传---------------')
      var _this = this
      this.utils.uploadImage(file, function (response) {
        Toast('上传图片成功')
        let imgUrl = response
        console.log('图片--------' + imgUrl)

        if (index === 0) {
          document.getElementById('card-left-img').src = 'http://cdn.zxzx119.com/' + imgUrl
          document.getElementById('card-left-img').style.left = '5px'
          document.getElementById('card-left-img').style.top = '5px'
          document.getElementById('card-left-img').style.width = 'calc(100% - 10px)'
          document.getElementById('card-left-img').style.height = '150px'
          document.getElementById('card-left-tip').style.top = '165px'
          document.getElementById('card-left-tip').innerHTML = '重新上传'
        }
        if (index === 1) {
          document.getElementById('card-right-img').src = 'http://cdn.zxzx119.com/' + imgUrl
          document.getElementById('card-right-img').style.left = '5px'
          document.getElementById('card-right-img').style.top = '5px'
          document.getElementById('card-right-img').style.width = 'calc(100% - 10px)'
          document.getElementById('card-right-img').style.height = '150px'
          document.getElementById('card-right-tip').style.top = '165px'
          document.getElementById('card-right-tip').innerHTML = '重新上传'
        }
        if (index === 2) {
          document.getElementById('cer-box1').src = 'http://cdn.zxzx119.com/' + imgUrl
        }
        if (index === 3) {
          document.getElementById('cer-box2').src = 'http://cdn.zxzx119.com/' + imgUrl
        }
        if (index === 4) {
          document.getElementById('cer-box3').src = 'http://cdn.zxzx119.com/' + imgUrl
        }

        if (index === 0) {
          _this.card_img_front = 'http://cdn.zxzx119.com/' + imgUrl
        }
        if (index === 1) {
          _this.card_img_back = 'http://cdn.zxzx119.com/' + imgUrl
        }

        if (index >= 2) {
          if ((_this.cerImgUrls.length <= index - 2)) {
            _this.cerImgUrls.push(imgUrl)
          }
          _this.cerImgUrls[index - 2] = imgUrl
        }
      })
    },
    delCerImg: function (index) { // 资质图片删除
      this.cerImgUrls.splice(index, 1)
      console.log(this.cerImgUrls.length)
      document.getElementById('cer-box1').src = this.emptyImg
      document.getElementById('cer-box2').src = this.emptyImg
      document.getElementById('cer-box3').src = this.emptyImg

      if (this.cerImgUrls.length >= 1) {
        document.getElementById('cer-box1').src = 'http://cdn.zxzx119.com/' + this.cerImgUrls[0]
      }
      if (this.cerImgUrls.length >= 2) {
        document.getElementById('cer-box2').src = 'http://cdn.zxzx119.com/' + this.cerImgUrls[1]
      }
      if (this.cerImgUrls.length >= 3) {
        document.getElementById('cer-box3').src = 'http://cdn.zxzx119.com/' + this.cerImgUrls[2]
      }
    },
    checkParam: function () {
      if(this.utils.loginState()!=1){
        Toast('请先登录')
        return false
      }
      if (this.real_name.length <= 0) {
        Toast('请输入真实姓名')
        return false
      }
      if (this.phone.length <= 0) {
        Toast('请输入联系方式')
        return false
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入联系方式')
        return false
      }
      if (this.code.length <= 0) {
        Toast('请输入验证码')
        return false
      }
      if (this.province.length <= 0) {
        Toast('请选择地区')
        return false
      }
      if (this.id_card_number.length <= 0) {
        Toast('请输入身份证号')
        return false
      }
      if (!this.utils.isCard(this.id_card_number)) {
        Toast('请正确输入身份证号')
        return false
      }
      if (this.level_title.length <= 0) {
        Toast('请选择等级职称')
        return false
      }
      if (this.card_img_front.length <= 0) {
        Toast('请选择身份证正面')
        return false
      }
      if (this.card_img_back.length <= 0) {
        Toast('请选择身份证背面')
        return false
      }
      if (this.cerImgUrls.length <= 0) {
        Toast('请选择资质照片')
        return false
      }
      if (this.isProtocol === 0) {
        Toast('请先阅读服务协议')
        return false
      }
      return true
    },
    enlistSubmit: function () {
      var param = {
        real_name: this.real_name,
        phone: this.phone,
        code: this.code,
        province: this.province,
        city: this.city,
        region: this.area,
        id_card_number: this.id_card_number,
        level_title: this.level_title,
        card_img_front: this.card_img_front,
        card_img_back: this.card_img_back,
        cert: this.cerImgUrls.join(',')
      }
      console.log(param)

      if (this.checkParam() === false) return

      var _this = this
      this.utils.POST(this.accountUrl + '/specialistJoin/save', param, function (response) {
        // 成功弹窗
        _this.showSuccessView = true
      })
    },
    successViewClick: function () {
      // 成功 界面 回调
      // 刷新界面
      this.showSuccessView = false
      this.reload()
      // app
      if (this.utils.isIphone()) { // ios
        console.log('ios平台=============1')
        window.webkit.messageHandlers.successApply.postMessage(null)
      } else {
        console.log('Android平台=============1')
        window.zxzx.successApply()
      }
    }
  },
  components: {
    mainHeader,
    bottomButton,
    AreaView,
    SPicker,
    InfoView,
    SuccessView,
    AliCaptcha
  },
  watch: {
  },
  mounted () {
    window._vueInstance = this;
    // 微信 分享
    wxShare.wxRegister('招募消防专家', '只要你够专业，即可成为中消消防专家组成员', 'http://cdn.zxzx119.com/1759303530708992')
  }
}

</script>

<style scoped lang="css">
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
#enlist-wrap {
  background-color: #ededed;

  margin-top: 55px;
  padding-bottom: 70px;
}
.enlist-header {
  width: 100%;
  height: 165px;
  background-image: url(../assets/icon_banner.png);
  background-size: cover;
  background-position: center center;
}
.enlist-header button {
  top: 120px;
  width: 72px;
  height: 30px;
  font-size: 12px;
  color: #ffffff;
  background-color: #c41335;
  border-radius: 2px;
  box-sizing: border-box;
  border: none;
}
.enlist-header .enlist-tip1 {
  position: absolute;
  left: calc(50% - 85px);
  /*left: -moz-calc( 50% - 80px );
  left: -webkit-calc( 50% - 80px );*/
}
.enlist-header .enlist-tip2 {
  position: absolute;
  left: calc(50% + 13px);
  /*left: -moz-calc( 50% + 8px );
  left: -webkit-calc( 50% + 8px );*/
}
.enlist-box {
  position: relative;
  width: 100%;
  height: 55px;
  line-height: 55px;
  border-bottom: #eeeeee solid 1px;
  box-sizing: border-box;
  background-color: #ffffff;
}
.enlist-box span {
  padding-left: 10px;
  width: 100px;
  font-size: 15px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: #323232;
}
.enlist-box input {
  position: absolute;
  top: 10px;
  left: 100px;
  width: calc(100% - 125px);
  height: 34px;
  line-height: 34px;
  font-size: 15px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: #000000;
  border: none;
  box-sizing: border-box;
  /*background-color: antiquewhite;*/
}
.enlist-box .input-code {
  width: calc(100% - 190px);
  /*background-color: #FF4949;*/
}
.enlist-box .button {
  position: absolute;
  right: 13px;
  top: 0px;
  text-align: right;
  width: 90px;
  height: 54px;
  font-size: 14px;
  color: #c41335;
  /*background-color: #FFEECC;*/
}
.enlist-box .next {
  position: absolute;
  left: calc(100% - 20px);
  top: 22px;
  width: 6px;
  height: 10px;
  background-image: url(../assets/next.png);
  background-size: cover;
  background-position: center center;
}
.enlist-info {
  position: relative;
  height: 300px;
  background-color: #faebd7;
  border-top: #ededed solid 10px;
  border-bottom: #eeeeee solid 1px;
  box-sizing: border-box;
  background-color: #ffffff;
}
.enlist-title {
  position: relative;
  margin-left: 15px;
  padding-top: 10px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #323232;
}
.enlist-tip {
  position: relative;
  top: 5px;
  margin-left: 15px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #bebebe;
}
.enlist-info .enlist-card {
  position: relative;
  top: 15px;
}
.enlist-info .card-box {
  width: calc((100% - 40px) / 2);
  height: 195px;
  background-color: #f6f6f6;
}
.enlist-info .card-left {
  position: absolute;
  left: 15px;
}
.enlist-info .card-right {
  position: absolute;
  right: 15px;
}
.card-box input {
  width: 100%;
  height: 195px;
  opacity: 0;
}
.enlist-info .card-img {
  position: absolute;
  left: calc(50% - 47px);
  top: 45px;
  width: 94px;
  height: 75px;
  /*视图点击穿透*/
  pointer-events: none;
}
.enlist-info .card-left-img {
  background-image: url(../assets/photo_left.png);
  background-size: cover;
  background-position: center center;
  object-fit: cover;
}
.enlist-info .card-right-img {
  background-image: url(../assets/photo_right.png);
  background-size: cover;
  background-position: center center;
  object-fit: cover;
}
.card-box .card-tip {
  position: absolute;
  width: 100%;
  top: 145px;
  text-align: center;
  font-size: 14px;
  color: #bebebe;
}

.enlist-cer {
  position: relative;
  height: 200px;
  background-color: #ffffff;
}
.enlist-cer-box {
  position: relative;
  top: 20px;
  width: calc(100% - 30px);
}
.enlist-cer-box .cer-box {
  position: relative;
  margin-left: 8px;
  left: 5px;
  float: left;
  width: 100px;
  height: 100px;
  background-color: #f6f6f6;
  background-image: url(../assets/addphoto.png);
  background-size: cover;
  background-position: center center;
  /*border: none;
  box-sizing: border-box;*/
}
.enlist-cer-box .cer-box img {
  /*position: absolute;*/
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.enlist-cer-box .cer-box input {
  position: absolute;
  width: 100px;
  height: 100px;
  opacity: 0;
  /*background-color: #FFEECC;*/
}
.enlist-cer-box .cer-box .cer-img-del {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  background-image: url(../assets/delete.png);
  background-size: cover;
  background-position: center center;
  /*background-color: #FFEECC;*/
}

.check-box {
  position: relative;
  top: 0px;
  width: 100%;
  height: 60px;
  font-size: 15px;
  color: #000000;
  box-sizing: border-box;
  border: none;
  border-top: solid 1px #f6f6f6;
  background-color: white;
}
.check-box img {
  position: absolute;
  top: 19px;
  left: 15px;
  width: 22px;
  height: 22px;
  /*object-fit: cover;*/
}
.check-box span {
  position: absolute;
  left: 50px;
  line-height: 60px;
  font-size: 15px;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/view/expert-recruit.vue